import { render } from "./ActiveTokens.vue?vue&type=template&id=5da2814e&scoped=true"
import script from "./ActiveTokens.vue?vue&type=script&lang=js"
export * from "./ActiveTokens.vue?vue&type=script&lang=js"

import "./ActiveTokens.vue?vue&type=style&index=0&id=5da2814e&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da2814e"]])

export default __exports__